const Loading = (props: { content: string }) => {
  return (
    <div className="loading">
      <div className="loading-ellipsis">
              <div>&nbsp;</div>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
              <div>&nbsp;</div>
      </div>
      <p>{props.content}</p>
    </div>
  );
};

export default Loading;
